
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import NavbarLogo from "@/components/layout/NavbarLogo";
import DesktopNav from "@/components/layout/DesktopNav";
import UserMenu from "@/components/layout/UserMenu";
import MobileMenu from "@/components/layout/MobileMenu";
import NavbarContainer from "@/components/layout/NavbarContainer";
import { useScrollPosition } from "@/hooks/useScrollPosition";

const Navbar = () => {
  const scrollPosition = useScrollPosition();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  // Check if current page is homepage
  const isHomePage = location.pathname === '/';

  return (
    <>
      <NavbarContainer 
        isScrolled={scrollPosition > 10} 
        className={location.pathname === '/' ? 'shadow-none' : ''}
      >
        {/* Logo and Desktop Nav */}
        <div className="flex items-center space-x-4 flex-grow">
          <NavbarLogo />
          <DesktopNav isHomePage={isHomePage} />
        </div>
        
        {/* Right Side Items */}
        <div className="flex items-center gap-4">
          {/* User Menu (Desktop) - Far right */}
          <div className="hidden md:flex">
            <UserMenu />
          </div>
          
          {/* Mobile Menu Button - Still on the right */}
          <div className="md:hidden">
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-foreground"
            >
              {isMobileMenuOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <Menu className="h-5 w-5" />
              )}
            </Button>
          </div>
        </div>
      </NavbarContainer>
      
      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} />
    </>
  );
};

export default Navbar;
